import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";
import ToolSidebar from "../../utils/ToolSideBar";
import "../../../css/partner/PartnerProfile.css";

export default function Partner({ data, loading, profileEndpoint }) {
  const user = data?.user || {};
  const partner = data?.partner || {};
  const position = data?.position || {};
  const compensation = data?.compensation || {};
  const isPartnerProfile = position.code === "partner" || partner.show_stripe;
  const stripeStatusLabel = partner.stripe_status_label || (partner.stripe_connected ? "Connected" : "Not Connected");
  const [form, setForm] = useState({ first_name: "", last_name: "", phone_number: "" });
  const [status, setStatus] = useState("");

  useEffect(() => {
    setForm({
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      phone_number: user.phone_number || "",
    });
  }, [user.first_name, user.last_name, user.phone_number]);

  async function saveProfile(event) {
    event.preventDefault();
    setStatus("Saving profile...");
    const response = await authFetch(profileEndpoint || `${API_URL}/partner/profile/`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const payload = await response.json();
    if (!response.ok) {
      setStatus(payload.detail || "Unable to save profile.");
      return;
    }
    setStatus("Profile saved.");
  }

  if (loading) return <div className="profile-loading">Loading...</div>;

  return (
    <div className="profile-shell">
      <ToolSidebar active="profile" />
      <div className="profile-page">
        <div className="profile-header">
          <h1>Profile</h1>
          <p>Manage the contact details clients and SCD staff use for your partner account.</p>
        </div>

        <div className="profile-grid">
          <form className="profile-card" onSubmit={saveProfile}>
            <h3>Contact Details</h3>
            <label className="profile-field">First Name
              <input value={form.first_name} onChange={(e) => setForm((current) => ({ ...current, first_name: e.target.value }))} />
            </label>
            <label className="profile-field">Last Name
              <input value={form.last_name} onChange={(e) => setForm((current) => ({ ...current, last_name: e.target.value }))} />
            </label>
            <label className="profile-field">Phone
              <input value={form.phone_number} onChange={(e) => setForm((current) => ({ ...current, phone_number: e.target.value }))} />
            </label>
            <button type="submit" className="profile-save">Save Profile</button>
            {status && <small>{status}</small>}
          </form>

          <div className="profile-card">
            <h3>Account</h3>
            <div className="profile-row"><span>Name</span><strong>{user.display_name || "Not provided"}</strong></div>
            <div className="profile-row"><span>Email</span><strong>{user.email || "Not provided"}</strong></div>
            {!isPartnerProfile && <div className="profile-row"><span>User ID</span><strong>{user.user_id || "Not provided"}</strong></div>}
            <div className="profile-row"><span>Joined</span><strong>{user.created_at ? new Date(user.created_at).toLocaleDateString() : "Not provided"}</strong></div>
            <div className="profile-row"><span>Status</span><strong>{partner.active ? "Active" : "Inactive"}</strong></div>
            <div className="profile-row"><span>Position</span><strong>{position.label || "Employee"}</strong></div>
            <div className="profile-row"><span>{compensation.label || "Compensation"}</span><strong>{compensation.display_value || "Not finalized"}</strong></div>
            {partner.show_stripe && <div className="profile-row"><span>Stripe</span><strong>{stripeStatusLabel}</strong></div>}
          </div>
        </div>
      </div>
    </div>
  );
}